export default __webpack_public_path__ + "static/kasia_kowalska-459274612cc7f29ecc9dc207e440988b.jpg";